import { QueryClient } from 'react-query';
import { sendError } from '@components/Noti';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      cacheTime: 180000, // 3min
      refetchOnWindowFocus: false,
      onError: (e: Error) => {
        sendError(e.message);
      },
    },
    mutations: {
      onError: (e: Error) => {
        sendError(e.message);
      },
    },
  },
});

export default queryClient;
